import Vue from 'vue'
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        language:null,
        /**
         * @type {PageRoyaumeModel[]}
         */
        pages:null,
        editable:false,
    },
    getters: {
        /**
         *
         * @param state
         * @return {PageRoyaumeModel}
         */
        getPageRoyaumeById: (state) => (id) => {
            return state.pages.find(page => page.id === Number(id))
        }
    },
    mutations: {
        language(value){
            this.state.language=value;
        },
        page(id,field,value){
            let p =this.getPageById(id);
            p[field]=value;
        }
    }
});
export default store;